import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSiteSettings } from "@/settings/useSiteSettings";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const { settings, loading } = useSiteSettings();

  useEffect(() => {
    if (loading) return;
    const target = settings.general.notFoundUrl || "/products";
    if (target && location.pathname !== target) {
      navigate(target, { replace: true });
    }
  }, [loading, settings, navigate, location.pathname]);

  return null;
}